<template>
  <div>
    <p class="text-red-500">
      {{ approvedMode }}
    </p>
    <div class="bg-white shadow sm:rounded-md">
      <div class="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
        <table class="table min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.txnRemark") }}
              </th>
              <!-- <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Bank
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider text-center"
              >
                Account Name
              </th> -->
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.accountId") }}
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.amount") }}
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.depositDate") }}
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.date") }}
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {{ $t("messages.approveTopup.remark") }}
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"></th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="data in dataRows" :key="data.deposit_id" class="hover:bg-gray-50">
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.txnRemark }}
              </td>
              <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.bank }}
              </td> -->
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.bank }}
                <!-- <br /><small>{{ data.bank_no }}</small> -->
              </td>
              <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.bank_name }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.bank_no }}
              </td> -->
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
                {{ data.deposit_amount }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                {{ getLocaleDate(data.deposit_datetime) }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                {{ getLocaleDate(data.createdate) }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {{ data.remark }}
              </td>
              <td class="text-right">
                <button
                  type="button"
                  v-if="store.state.user.permissions.includes('RTB.DEPOSIT.REJECT')"
                  @click="toggleModal(data, 'reject')"
                  class="mr-5 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-red-500"
                >
                  {{ $t("messages.approveTopup.rejectTopup") }}
                </button>
                <button
                  type="button"
                  v-if="store.state.user.permissions.includes('OPERATOR.READ.FINANCE_APPROVE_TOPUP')"
                  @click="toggleModal(data, 'approved')"
                  class="mr-5 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
                >
                  {{ $t("messages.approveTopup.approveTopup") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex flex-row justify-end p-4">
          <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a
              href="javascript:void(0)"
              @click="jump(1)"
              class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span class="sr-only">First</span>
              <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-double-left']" transform="shrink-2" /></span>
            </a>
            <a href="javascript:void(0)" @click="prev" class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Previous</span>
              <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-left']" transform="shrink-2" /></span>
            </a>

            <a
              href="javascript:void(0)"
              @click="jump(i)"
              v-for="i in totalPages"
              :key="i"
              :class="
                currentPage === i
                  ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
                  : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-block items-center py-2 w-10 text-center border text-sm font-medium'
              "
              style="cursor: pointer"
            >
              {{ i }}
            </a>
            <a href="javascript:void(0)" @click="next" class="relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
              <span class="sr-only">Next</span>
              <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-right']" transform="shrink-2" /></span>
            </a>
            <a
              href="javascript:void(0)"
              @click="jump(totalPages)"
              class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span class="sr-only">Last</span>
              <span class="h-5 w-5 text-center"><font-awesome-icon class="text-gray-500" :icon="['fas', 'chevron-double-right']" transform="shrink-2" /></span>
            </a>
          </nav>
        </div>
      </div>
    </div>
    <TransitionRoot as="template" :show="approveModalOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="approveModalOpen = false" :open="approveModalOpen">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full" :class="approvedMode == 'reject' ? 'bg-red-100' : 'bg-green-100'">
                  <div v-if="approvedMode == 'reject'">
                    <XCircleIcon class="h-16 w-16 text-red-400" aria-hidden="true" />
                  </div>
                  <div v-else>
                    <font-awesome-icon class="text-green-600" :icon="['far', 'check']" transform="grow-2" />
                  </div>
                </div>
                <div class="mt-2 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900"> {{ approvedMode == "reject" ? "Reject Topup" : "Approve Topup" }} </DialogTitle>
                  <div class="rounded-md bg-red-50 p-4 text-left mt-3" v-show="hasError">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <XCircleIcon class="h-5 w-5 text-red-400" aria-hidden="true" />
                      </div>
                      <div class="ml-3">
                        <h3 class="text-sm font-medium text-red-800">
                          {{ errorMessage }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="pt-5 text-left">
                    <b>Bank</b>: {{ selected.bank }}<br />
                    <b>Bank Account Name</b>: {{ selected.bank_name || "-" }}<br />
                    <b>Bank No.</b>: {{ selected.bank_no || "-" }}<br />
                    <b>TxnRemark</b>: {{ selected.txnRemark || "-" }}<br />
                    <b>Remark</b>: {{ selected.remark || "-" }}<br />
                    <!-- <b>Deposit ID</b>: {{ selected.deposit_id || '-' }}<br>
                    <b>Member ID</b>: {{ selected.member_id || '-' }}<br> -->
                    <b>Deposit Date</b>: {{ dayjs(selected.deposit_datetime).locale("th").format("LLL") || "-" }}<br />
                    <b>Created Date</b>: {{ dayjs(selected.createdate).locale("th").format("LLL") || "-" }}<br />
                  </div>
                  <div class="mt-6 pb-2 text-left">
                    <label class="text-sm">Amount</label>
                    <div class="mt-1">
                      <span class="inline-block border-2 px-2 py-2 shadow-sm w-full sm:text-sm border-gray-300 rounded-md">{{ selected.deposit_amount }}</span>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left" v-if="!selected.memberId && approvedMode !== 'reject'">
                    <label class="text-sm">Customer Phone Number</label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model="selected.customer_code"
                        name="customerCode"
                        id="customerCode"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="08XXXXXXXX"
                      />
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left" v-if="approvedMode == 'reject'">
                    <label class="text-sm">Remarks</label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model="selected.customer_code"
                        name="customerCode"
                        id="customerCode"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="Remarks"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button
                  type="button"
                  :disabled="isWorking"
                  @click="approvedMode == 'reject' ? saveRejectTransaction() : saveTransaction()"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:col-start-2 sm:text-sm"
                  :class="approvedMode == 'reject' ? ' bg-red-600 text-base  hover:bg-red-700 focus:ring-red-500' : ' bg-blue-600 text-base  hover:bg-blue-700 focus:ring-blue-500'"
                >
                  <font-awesome-icon v-if="isWorking" class="text-white" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
                  <p v-else><span v-if="approvedMode == 'reject'">Reject Topup</span> <span v-else>Confirm Topup</span></p>
                </button>
                <button
                  type="button"
                  @click="toggleModal()"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef"
                >
                  Cancel
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import { defineComponent, ref, inject, computed } from "vue";
import * as dayjs from "dayjs";
import "dayjs/locale/th";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useStore } from "vuex";

dayjs.extend(localizedFormat);

import { CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon, MailIcon, HomeIcon, SearchIcon, XCircleIcon, SelectorIcon, CheckIcon } from "@heroicons/vue/solid";
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot, Listbox, ListboxButton, ListboxLabel, ListboxOption, ListboxOptions } from "@headlessui/vue";
export default defineComponent({
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    XCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    Listbox,
    ListboxButton,
    ListboxLabel,
    ListboxOption,
    ListboxOptions,
    SelectorIcon,
    CheckIcon,
  },
  props: {
    dataRows: Array,
    selected_payment: String,
    count: Number,
    totalPages: Number,
    currentPage: Number,
  },
  emits: ["onSubmit", "onRefetchData"],
  setup(props, { emit }) {
    const axios = inject("$axios");
    let approveModalOpen = ref(false);
    const selected = ref({});
    let hasError = ref(false);
    let errorMessage = ref("");
    const isWorking = ref(false);
    const store = useStore();
    let isApproved = ref(false);
    const approvedMode = ref();

    // const currentPage = ref(1)
    const offset = ref(0);
    const rowsPerPage = ref({ label: "10", value: 10 });

    const totalPages = computed(() => props.totalPages);

    // console.log({ itemsCount: totalPages.value })

    const refetchData = (page) => {
      emit("onRefetchData", page);
    };

    const getLocaleDate = (date) => {
      return dayjs(date).locale("th").format("LLL");
    };
    const toggleModal = (data, mode) => {
      console.log(data);
      console.log(mode);
      approvedMode.value = mode;
      // if(mode) approvedMode.value = mode
      if (data) {
        selected.value = data;
      }
      selected.value.customer_code = "";
      approveModalOpen.value = !approveModalOpen.value;
    };

    const saveRejectTransaction = () => {
      isWorking.value = true;
      console.log(selected.value);

      if (props.selected_payment == "RTB") {
        //RTB
        console.log({
          rtb_id: selected.value.deposit_id,
          // user_phone: "",
          admin_id: store.state.user.username, //decode.userId
          member_id: selected.value.memberId,
          operator_id: store.state.selectedOperator.operatorId,
          remark: selected.value.customer_code
        })
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/internal/rtb/internal/deposits/reject", {
            rtb_id: selected.value.deposit_id,
            // user_phone: "",
            admin_id: store.state.user.username, //decode.userId
            member_id: selected.value.memberId,
            operator_id: store.state.selectedOperator.operatorId,
            remark: selected.value.customer_code
          })
          .then(({ data }) => {
            if (data.success || data.status == "success" || data.amount) {
              emit("onSubmit");
              isWorking.value = false;
              approveModalOpen.value = !approveModalOpen.value;
            } else {
              hasError.value = true;
              errorMessage.value = data.msg;
              isWorking.value = false;
            }
          })
          .catch((err) => {
            console.log(err);
            hasError.value = true;
            errorMessage.value = err.response.data.message;
            isWorking.value = false;
          });
      }
    };

    const saveTransaction = () => {
      isWorking.value = true;

      if (props.selected_payment == "RTB") {
        //RTB
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/internal/rtb/internal/deposits/approve", {
            rtb_id: selected.value.deposit_id,
            user_phone: selected.value.customer_code,
            admin_id: store.state.user.username, //decode.userId
            member_id: selected.value.memberId,
            operator_id: store.state.selectedOperator.operatorId,
          })
          .then(({ data }) => {
            // console.log( 'data', data );
            if (data.success || data.status == "success") {
              emit("onSubmit");
              isWorking.value = false;
              approveModalOpen.value = !approveModalOpen.value;
            } else {
              hasError.value = true;
              errorMessage.value = data.msg;
              isWorking.value = false;
            }
          })
          .catch((err) => {
            console.log(err);
            hasError.value = true;
            errorMessage.value = err.response.data.message;
            isWorking.value = false;
          });
      } else {
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/transactions/pending/deposit", {
            id: selected.value.deposit_id,
            customer_code: selected.value.customer_code,
            member_id: selected.value.memberId,
            username: store.state.user.username,
            operatorId: store.state.selectedOperator.operatorId,
          })
          .then(({ data }) => {
            if (data.success) {
              emit("onSubmit");
              isWorking.value = false;
              approveModalOpen.value = !approveModalOpen.value;
            } else {
              hasError.value = true;
              errorMessage.value = data.msg;
              isWorking.value = false;
            }
          })
          .catch((err) => {
            console.log(err);
            hasError.value = true;
            errorMessage.value = err.response.data.message;
            isWorking.value = false;
          });
      }
    };

    const prev = () => {
      if (props.currentPage - 1 >= 1) {
        refetchData((props.currentPage -= 1));
      }
    };

    const next = () => {
      if (props.currentPage + 1 <= totalPages.value) {
        refetchData((props.currentPage += 1));
      }
    };
    const jump = (page) => {
      refetchData(page);
    };

    return {
      dayjs,
      getLocaleDate,
      toggleModal,
      saveRejectTransaction,
      saveTransaction,
      prev,
      next,
      jump,
      // currentPage,
      totalPages,
      approveModalOpen,
      selected,
      hasError,
      errorMessage,
      isWorking,
      isApproved,
      store,
      approvedMode,
    };
  },
});
</script>

<style></style>
